import { SET_TEXT_TO_SPEAK, FINISHED_SPEAKING, LOAD_TEXT, SET_CURRENT_LINE, SET_DATA, IS_PLAYING, ALREADY_PLAYED } from "../actions/text.action";

const initialState = {
    textToSpeak: "",
    pageText: [],
    currentLine: "",
    playerStatus: "PLAYING",
    data: null,
    playing: false,
    alreadyPlayed: false
};

export default function textReducer(state = initialState, action: any) {
    if (action.type === SET_TEXT_TO_SPEAK) {
        let text =  action.text;
        return {
            ...state,
            textToSpeak: text
        }
    }
    if (action.type === FINISHED_SPEAKING) {
        return {
            ...state,
            textToSpeak: "",
            currentLine: ""
        }
    }
    if (action.type === LOAD_TEXT) {
        return {
            ...state,
            pageText: action.text
        }
    }
    if (action.type === SET_CURRENT_LINE) {
        return {
            ...state,
            currentLine: action.currentLine
        }
    }
    if (action.type === SET_DATA) {
        return {
            ...state,
            data: action.data
        }
    }
    if (action.type === IS_PLAYING) {
        return {
            ...state,
            playing: action.isPlaying
        }
    }
    if(action.type === ALREADY_PLAYED) {
        return{
            ...state,
            alreadyPlayed: action.status
        }
    }
    return state;
}  